module.exports = __webpack_public_path__ + "img/connect-6.8681c69d.svg";